"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const formik_1 = require("formik");
const ui_1 = require("../ui");
const SNODisclaimer_1 = tslib_1.__importDefault(require("./SNODisclaimer"));
const featureSupportLevels_1 = require("../featureSupportLevels");
const SNOControlGroup = ({ versions, highAvailabilityMode }) => {
    const { values } = (0, formik_1.useFormikContext)();
    const featureSupportLevelContext = (0, featureSupportLevels_1.useFeatureSupportLevel)();
    const snoSupportLevel = featureSupportLevelContext.getFeatureSupportLevel(values.openshiftVersion, 'SNO');
    const snoExpansion = featureSupportLevelContext.isFeatureSupported(values.openshiftVersion, 'SINGLE_NODE_EXPANSION');
    const isDisabled = featureSupportLevelContext.isFeatureDisabled(values.openshiftVersion, 'SNO');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ui_1.SingleNodeCheckbox, { name: "highAvailabilityMode", versions: versions, isDisabled: isDisabled }),
        highAvailabilityMode === 'None' && snoSupportLevel && (react_1.default.createElement(SNODisclaimer_1.default, { isDisabled: isDisabled, snoSupportLevel: snoSupportLevel, snoExpansionSupported: snoExpansion }))));
};
exports.default = SNOControlGroup;
//# sourceMappingURL=SNOControlGroup.js.map